import React, { useState } from "react";
import { useSelector } from "react-redux";
import PaymentCard from "../../../../components/PaymentCard";
import axios from "axios";
import "./index.scss";
import download from "downloadjs";
import env from "../../../../env";
import { base64 } from "../../../../constants/validate";

export default function FinalizedProposal({
  direction = "row",
  origin,
  unpaid = false,
}) {
  const { archivedProposals, unpaidProposals } = useSelector(
    (state) => state.charge
  );

  const { oldProposals, currentCase } = useSelector((state) => state.crm);
  console.log(currentCase)
  const [loading, setLoading] = useState(false);
  let proposals = origin === "debtor" ? archivedProposals : oldProposals;
  if (unpaid) proposals = unpaidProposals;

  function returnClassNameContainer() {
    let className = "finalized-proposal__container";

    if (direction === "column")
      className += " finalized-proposal__container--column";

    return className;
  }

  function downloadMinute(id) {
    setLoading(true);
    axios
      .get(`/proposal/download-minute/${id}`)
      .then((response) => {
        const file = window.atob(response.data);
        download(file, `Minuta`, "application/pdf");
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }
  function downloadSignedMinute() {
    setLoading(true);
    let token =
      env === "development"
        ? "830b013e0b3a4112b20db7673bfb303d"
        : "93787308c6904130959e60dc4af0e379";
    let headers = { headers: { token } };
    axios
      .get(currentCase.case.document_url, headers)
      .then((response) => {
        download(
          base64(response.data.bytes),
          response.data.name,
          response.data.mimeType
        );
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }
  return (
    <div className="finalized-proposal">
      <div>
        {proposals.map((proposal, index) => {
          let totalWithFees = 0;

          if (proposal.length > 0) {
            //totalWithFees = proposal.length * proposal[proposal.length - 1].value;
            totalWithFees = proposal[proposal.length - 1].number_installments * proposal[proposal.length - 1].value;
          }

          return (
            <div className={returnClassNameContainer()} key={index}>
              <p>Proposta {index + 1}</p>
              <div>
                {proposal[0]?.number_installments === 1 && (
                  <PaymentCard
                    type="toSelect"
                    typePayment="À vista"
                    way="Boleto bancário"
                    total={proposal[0]?.value}
                    discount={1}
                    minHeight="150px"
                  />
                )}
                {unpaid ? (
                  <PaymentCard
                    type="toSelect"
                    typePayment="Parcelado"
                    way="Boleto bancário"
                    total={totalWithFees}
                    numberInstallments={proposal[0]?.number_installments}
                    valueInstallments={proposal[0]?.value}
                    minHeight="150px"
                    unpaid={true}
                    // downloadMinute={() => downloadMinute(proposal[0].id)}


                    downloadMinute={() =>
                      currentCase.case.document_url
                        ? downloadSignedMinute()
                        : downloadMinute(proposal[0].id)
                    }
                    loading={loading}
                  />
                ) : (
                  <PaymentCard
                    type="toSelect"
                    typePayment="Parcelado"
                    way="Boleto bancário"
                    total={totalWithFees}
                    numberInstallments={proposal.length}
                    valueInstallments={proposal[proposal.length - 1]?.value}
                    minHeight="150px"
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
